import ScrollMagic from 'scrollmagic';
import { TweenMax, TimelineMax } from "gsap/all";
require('animation.gsap');
import { getViewportProperties } from '../layout/layout'
import debounce from 'lodash/debounce';


// set null controller
let scrollSpyController = null

const initScrollSpy = ()=>{
    const viewportProperties = getViewportProperties();

    // get scroll spy links
    const scrollSpyLinks = document.querySelectorAll('#header .sub-nav__link');

    if( scrollSpyLinks && ( viewportProperties.orientation == 'landscape' &&  viewportProperties.width > 767 ) ){
        // USE SCROLLMAGIC
        // console.log('setup scroll spy');

        // set new controller
        scrollSpyController = new ScrollMagic.Controller();
        // get all links into array
        const scrollSpyLinksArray = Array.from(scrollSpyLinks);
        // set scene for each link
        scrollSpyLinksArray.forEach(scrollSpyLink => {
            // get href
            const linkHref = scrollSpyLink.getAttribute('href');

            // link section enter
            new ScrollMagic.Scene({
                triggerElement: linkHref,
                triggerHook: 'onEnter',
                offset: viewportProperties.height / 2,
            })
            .on('start', function (event) {
                if( event.scrollDirection == 'FORWARD' ){
                    manageSpyClasses(linkHref,scrollSpyLinksArray);
                }
            })
            .addTo(scrollSpyController);

            // link section out
            new ScrollMagic.Scene({
                triggerElement: linkHref,
                triggerHook: 'onCenter',
                offset: viewportProperties.height / 2,
            })
            .on('start', function (event) {
                if( event.scrollDirection == 'REVERSE' ){
                    manageSpyClasses(linkHref,scrollSpyLinksArray);
                }
            })
            .addTo(scrollSpyController);

        });
        
    } else {

        // REMOVE SCROLLMAGIC
        if( scrollSpyController ){
            scrollSpyController.destroy(true);
            scrollSpyController = null;
            // console.log('remove scroll spy');
        }

    }


}


// add and remove css classes
const manageSpyClasses = ( elementId, linksArray )=>{
    // console.log(elementId+ " is visible");
    linksArray.forEach(linkItem => {
        // get href
        const linkHref = linkItem.getAttribute('href');
        // if link's href matches ID make active
        if( elementId == linkHref ){
            linkItem.classList.add('scrollspy--active');
        } else {
            linkItem.classList.remove('scrollspy--active');
        }
    })
}



// Set up Scroll Spy on load
initScrollSpy();

// Reset Scroll Spy on resize
window.addEventListener('resize', debounce(  ()=>{
    initScrollSpy();
}, 150) );